import { useState } from "react";
import styled from "styled-components";

import { HeaderRoundIconButton, HeaderRoundIcon } from "./GlobalAudioToggle";
import ShortcutGuideDrawer from "../../shortcut-guide/ShortcutGuideDrawer";

/**
 * キーボードショートカットは物理キーボード前提の機能のため、PC 表示に限定する。
 * SP（< 768px。Preview の DESKTOP_BREAKPOINT と同じ境界）ではボタン自体を隠す。
 */
const DesktopOnlyRoundButton = styled(HeaderRoundIconButton)`
  @media (max-width: 767px) {
    display: none;
  }
`;

/**
 * グローバルヘッダー右端の「?」ボタン（PC 限定表示）。
 * クリックでキーボードショートカット一覧ドロワー（ShortcutGuideDrawer）を開く。
 * 見た目は隣の HeaderAudioToggle と同一（40px 円形 + Material Symbols 20px）。
 */
const HeaderShortcutHelp = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <DesktopOnlyRoundButton
        onClick={() => setIsOpen(true)}
        aria-label="キーボードショートカット"
      >
        <HeaderRoundIcon className="material-symbols-rounded">
          question_mark
        </HeaderRoundIcon>
      </DesktopOnlyRoundButton>
      <ShortcutGuideDrawer open={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

export default HeaderShortcutHelp;
